import { NormalizeApi } from '@kakadu-dev/base-frontend-components/lib/modules/normalizeApi'

const BASE_ENDPOINT = 'base.rpc.customers'

export const StylistFormApi = NormalizeApi({
	create:        `${BASE_ENDPOINT}.evening-with-stylist`,
})
